import { Grid, H, P, Wrapper } from '@farewill/ui'
import { BORDER, COLOR, FONT, GTR } from '@farewill/ui/tokens'
import styled from 'styled-components'
import { useFormikContext } from 'formik'

import RadioGroup from 'components/form/radio-group'
import { FuneralPlanAttributes } from 'lib/models/funeral-plan'
import {
  CELEBRATION_PURCHASE,
  getCelebrationInterestStatus,
} from './celebration-helpers'
import { CaseDetailsSectionProps } from './types'

/** Provisional interest-status treatment pending design review with Lottie. */
const StatusBanner = styled(Wrapper)<{
  $status: 'legacy' | 'later' | 'no'
}>`
  border: 2px solid
    ${({ $status }) =>
      $status === 'legacy'
        ? COLOR.ACCENT.SECONDARY
        : $status === 'later'
          ? COLOR.STATE.WARNING
          : COLOR.GREY.MEDIUM};
  border-radius: ${BORDER.RADIUS.S};
  padding: ${GTR.S};
  background-color: ${COLOR.WHITE};
  font-size: ${FONT.SIZE.S};
`

const STATUS_COPY = {
  legacy: 'No celebration interest recorded (legacy plan).',
  later: 'Will consider adding a celebration later.',
  no: 'Not interested in adding a celebration.',
} as const

const CelebrationInterest = ({
  handleSave,
}: CaseDetailsSectionProps): React.ReactElement | null => {
  const { values } = useFormikContext<FuneralPlanAttributes>()
  const status = getCelebrationInterestStatus({
    items: values.items,
    celebrationPurchase: values.celebrationPurchase,
  })

  if (status === 'purchased') return null

  return (
    <Grid.Item data-testid="celebration-interest">
      <H size="S">Celebration interest</H>
      <StatusBanner
        $status={status}
        margin={[0, 0, 'S']}
        data-testid={`celebration-interest-${status}`}
      >
        <P margin={0}>{STATUS_COPY[status]}</P>
      </StatusBanner>
      <RadioGroup
        name="celebrationPurchase"
        label="Would they like to add a gathering at the crematorium later?"
        options={[
          {
            label: 'Will consider adding later',
            value: CELEBRATION_PURCHASE.LATER,
          },
          { label: 'Not interested', value: CELEBRATION_PURCHASE.NO },
        ]}
        handleSave={({ name, value }) => handleSave({ name, value })}
      />
    </Grid.Item>
  )
}

export default CelebrationInterest
